import {AfterViewInit, Component, EventEmitter, Output, ViewChild, Input} from '@angular/core';
import {ImportComponentComponent} from "../../shared/import-component/import-component.component";
import {ApiPathsService} from "../../api-paths.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-import-aziende',
  templateUrl: './import-referenti.component.html'
})
export class ImportReferentiComponent implements AfterViewInit {

  @Output() Uploaded = new EventEmitter<any>();
  @Input() Cliente: number;
  @ViewChild('ImportComponent')
  private ImportComponent:  ImportComponentComponent;
  constructor(
    private apiPaths: ApiPathsService,
    private modalService : NgbActiveModal,
  ) { }
  ngAfterViewInit(): void {
    this.ImportComponent.updateSelectedUrl(this.apiPaths.getBaseAPI() + '/anagrafica/clienti/referenti/import');
    this.ImportComponent.parametri = {'cliente': this.Cliente.toString()} ;
  }
  uploaded(event){
    this.Uploaded.emit(event);
  }

  closeModal() {
    this.modalService.dismiss();
  }
}
